import {
  baseQueryArgs,
  baseExtraOptions,
  rsosApi,
  CURRENT_ORGANIZATION_NAME,
  TOKEN_TYPE_ACCESS_TOKEN,
} from '../rsosApi';

function getBaseUrl() {
  return 'v1/public-services/video-to-911-v1';
}

export const videoTo911Api = rsosApi.injectEndpoints({
  endpoints: builder => ({
    createRoom: builder.mutation({
      query: ({ accountId, callerId, callStartTime }) => ({
        ...baseQueryArgs,
        url: `${getBaseUrl()}/rooms`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${TOKEN_TYPE_ACCESS_TOKEN}`,
          'X-RapidSOS-Org': CURRENT_ORGANIZATION_NAME,
        },
        body: {
          account_id: accountId,
          caller_id: callerId,
          call_start_time: callStartTime,
        },
      }),
      extraOptions: {
        ...baseExtraOptions,
      },
    }),
    endRoom: builder.mutation({
      // eslint-disable-next-line no-unused-vars -- used in slice to map to room id
      query: ({ accountId, callerId, callStartTime, roomId }) => ({
        ...baseQueryArgs,
        url: `${getBaseUrl()}/rooms`,
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${TOKEN_TYPE_ACCESS_TOKEN}`,
          'X-RapidSOS-Org': CURRENT_ORGANIZATION_NAME,
        },
        body: {
          account_id: accountId,
          caller_id: callerId,
          call_start_time: callStartTime,
        },
      }),
      extraOptions: {
        ...baseExtraOptions,
      },
    }),
    /**
     * Refresh the clientToken. Unauthenticated endpoint. Does not require
     * accessToken or productToken
     * @param {String} roomId - ID of the room for a video session
     * @param {String} refreshToken - Refresh token
     * @param {String} module - Video provider
     */
    refreshClientToken: builder.mutation({
      query: ({ roomId, refreshToken, module }) => ({
        ...baseQueryArgs,
        url: `${getBaseUrl()}/tokens/refresh`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${TOKEN_TYPE_ACCESS_TOKEN}`,
          'X-RapidSOS-Org': CURRENT_ORGANIZATION_NAME,
        },
        body: {
          room_id: roomId,
          refresh_token: refreshToken,
          module,
        },
        extraOptions: {
          ...baseExtraOptions,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateRoomMutation,
  useEndRoomMutation,
  useRefreshClientTokenMutation,
} = videoTo911Api;
